module.exports = __webpack_public_path__ + "media/images/unauthorized_access-1c65569deb732f71f5e9027203e4d35a.svg";